import { render, staticRenderFns } from "./AddNewAdvertise.vue?vue&type=template&id=18415ec4&scoped=true"
import script from "./AddNewAdvertise.vue?vue&type=script&lang=js"
export * from "./AddNewAdvertise.vue?vue&type=script&lang=js"
import style0 from "./AddNewAdvertise.vue?vue&type=style&index=0&id=18415ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18415ec4",
  null
  
)

export default component.exports